"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Icon_1 = require("office-ui-fabric-react/lib/Icon");
var Spinner_1 = require("office-ui-fabric-react/lib/Spinner");
var owa_controls_feature_flags_1 = require("owa-controls-feature-flags");
var owa_strings_1 = require("owa-strings");
var owa_common_strings_1 = require("owa-strings/owa-common-strings");
var React = require("react");
var styles = require('./FindRecipientInfo.scss');
var classNames = require('classnames/bind').bind(styles);
var FindRecipientInfoType;
(function (FindRecipientInfoType) {
    FindRecipientInfoType[FindRecipientInfoType["Default"] = 0] = "Default";
    FindRecipientInfoType[FindRecipientInfoType["Searching"] = 1] = "Searching";
    FindRecipientInfoType[FindRecipientInfoType["TypeToSearch"] = 2] = "TypeToSearch";
    FindRecipientInfoType[FindRecipientInfoType["SearchDirectory"] = 3] = "SearchDirectory";
    FindRecipientInfoType[FindRecipientInfoType["TopNResults"] = 4] = "TopNResults";
    FindRecipientInfoType[FindRecipientInfoType["UseAddress"] = 5] = "UseAddress";
})(FindRecipientInfoType = exports.FindRecipientInfoType || (exports.FindRecipientInfoType = {}));
var FindRecipientInfo = function (props) {
    var isConsumerUser = owa_controls_feature_flags_1.isControlFeatureEnabled('doc-consumerUrl');
    switch (props.infoType) {
        case FindRecipientInfoType.Searching:
            return (React.createElement("div", { className: styles.container },
                React.createElement("div", { className: styles.iconContainer },
                    React.createElement(Spinner_1.Spinner, { className: styles.loadingSpinner })),
                React.createElement("div", { className: styles.textContainer }, owa_strings_1.format(owa_common_strings_1.default.findRecipientInfo_Searching, props.queryString))));
        case FindRecipientInfoType.TypeToSearch:
            return (React.createElement("div", { className: styles.container },
                React.createElement("div", { className: classNames(styles.textContainer, styles.centered) }, owa_common_strings_1.default.findRecipientInfo_TypeToSearch)));
        case FindRecipientInfoType.SearchDirectory:
            return (props.searchDirectoryAction && (React.createElement("div", { className: classNames(styles.container, styles.hoverable, {
                    isHighlighted: props.highlighted,
                }), onClick: props.searchDirectoryAction },
                React.createElement("div", { className: styles.iconContainer },
                    React.createElement(Icon_1.Icon, { className: styles.searchIcon, iconName: "Search" /* Search */ })),
                React.createElement("div", { className: styles.textContainer }, isConsumerUser
                    ? owa_common_strings_1.default.findRecipientInfo_SearchPeople
                    : owa_common_strings_1.default.findRecipientInfo_SearchDirectory))));
        case FindRecipientInfoType.TopNResults:
            return (React.createElement("div", { className: styles.container },
                React.createElement("div", { className: classNames(styles.textContainer, styles.centered) }, props.numberOfResults
                    ? owa_strings_1.format(owa_common_strings_1.default.findRecipientInfo_TopNResults, props.numberOfResults)
                    : owa_common_strings_1.default.findRecipientInfo_NoResultsFound)));
        case FindRecipientInfoType.UseAddress:
            return (props.useTypedAddressAction && (React.createElement("div", null,
                React.createElement("div", { className: classNames(styles.hoverable, {
                        isHighlighted: props.highlighted,
                    }) },
                    React.createElement("div", { className: classNames(styles.textContainer, styles.useAddressContainer), onClick: props.useTypedAddressAction }, owa_strings_1.format(owa_common_strings_1.default.findRecipientInfo_UseThisAddress, props.queryString))),
                React.createElement(FindRecipientInfo, { infoType: FindRecipientInfoType.TopNResults, highlighted: false, queryString: props.queryString, numberOfResults: props.numberOfResults }))));
        default:
            return null;
    }
};
exports.default = FindRecipientInfo;
//# sourceMappingURL=FindRecipientInfo.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-recipient-common/lib/components/FindRecipientInfo.js
// module id = 2753
// module chunks = 2 3 63